'use client';

import {FormEvent, useContext, useState} from "react";
import {IMaskInput } from "react-imask";
import {TranslationContext} from "@/context/translation/TranslationContext";
import {AMO_CRM_TAG_IDS} from "@/data/common";
import {useRouter, useSearchParams} from "next/navigation";

const isDev = process.env.NODE_ENV === "development";
const BASE_URL = isDev
  ? "http://localhost:3000"
  : process.env.NEXT_PUBLIC_BASE_URL;

export const PlatformApplicationForm = ({btnLabel, piplineId}: {btnLabel?: string, piplineId: number}) => {
    const searchParams = useSearchParams();
    const {dictionary, lang} = useContext(TranslationContext);
    const [loading, setLoading] = useState(false);
    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');
    const [platformTransfer, setPlatformTransfer] = useState('');
    const router = useRouter()
    const [agreement, setAgreement] = useState(false);

    function validatePhoneNumber() {
        // Check if the phone number starts with '+7'
        if (!phone.startsWith('7')) {
            alert(dictionary["enter_phone_correctly"]);
            return false; // Prevent form submission
        }

        // Check if the phone number has the full length of digits
        if (phone.length !== 11) {
            alert(dictionary["enter_phone_correctly"]);
            return false; // Prevent form submission
        }

        // Remove the '+7' prefix
        const numberWithoutPrefix = phone.substring(1);
        const allowedPrefixes = ['700', '701', '702', '705', '706', '707', '708', '747', '771', '775','776', '777', '778'];
        // Check if the number without prefix starts with any allowed prefix
        const isValidPrefix = allowedPrefixes.some(prefix => numberWithoutPrefix.startsWith(prefix));

        if (!isValidPrefix) {
            alert(dictionary["enter_phone_correctly_2"]);
            return false; // Prevent form submission
        }

        return true; // Allow form submission if all phone numbers are valid
    }

        const handleChange = (value: string) => {
            setPhone(`7${value}`)
        }

        const handleSubmit = (event: FormEvent<any>) => {
            setLoading(true);
            event.preventDefault();

        if (!validatePhoneNumber()) {
            return setLoading(false);
        }

        if (!platformTransfer) {
            alert(dictionary["platform_transfer_required"]);
            return setLoading(false);
        }
        const comment = `${dictionary["platform_transfer_question"]}: ${dictionary[platformTransfer]}`;

        const data = {
            "utm_source": searchParams?.get('utm_source') || "",
            "utm_medium": searchParams?.get('utm_medium') || "",
            "utm_campaign": searchParams?.get('utm_campaign') || "",
           "utm_content": searchParams?.get('utm_content') || "",
            "utm_term": searchParams?.get('utm_term') || "",
            // "name": name,
            "clientName": name,
            "phone": phone,
            "clientComment": comment,
            "path": window.location.href,
            "email": "",
            "tagIds": [AMO_CRM_TAG_IDS[lang.toUpperCase()]],
            "roistat": "",
            "pipelineId": 4545103
        }

        fetch(`${isDev ? `${BASE_URL}/api/proxy/amocrm/` : process.env.NEXT_PUBLIC_AMOCRM_URL}create-lead`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                router.push('/thanks');
            })
            .finally(() => {
                setLoading(false);
        });
    }

    return <form className="platform-cont-form" onSubmit={handleSubmit} method='POST' action='#'>
        <div className="platform-form">
             <input
                type="text"
                name="name" 
                className="form-input-platform" 
                placeholder={dictionary["name"]} 
                value={name} 
                onChange={(e) => setName(e.target.value)} 
                required
            />
            <IMaskInput
                mask={'+{7}(700)000-00-00'}
                type="phone"
                name="phone"
                className="form-input-platform"
                placeholder={dictionary["phone_number"]}
                required
                inputMode="numeric"
                unmask={true}
                onAccept={(value) => setPhone(`7${value}`)}
            />
        </div>
        <div className="platform-radio pad-t-20">
            <p className="pad-b-12">{dictionary["platform_transfer_question"]}</p>
            <div>
                <label>
                    <input 
                        type="radio" 
                        name="comment" 
                        value="no" 
                        checked={platformTransfer === "no"} 
                        onChange={() => setPlatformTransfer("no")} 
                    />
                    {dictionary["no"]}
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="comment"
                        value="yes" 
                        checked={platformTransfer === "yes"} 
                        onChange={() => setPlatformTransfer("yes")} 
                    />
                    {dictionary["yes"]}
                </label>                
            </div>
            
        </div>
        <div className="pad-t-48">
             <label className="ji-gray ji-14">
                <input 
                    type="checkbox" 
                    checked={agreement} 
                    onChange={() => setAgreement(!agreement)}
                    required
                />
                {dictionary["agree_terms"]}
            </label>
        </div>

        <button
            className={`mt-16 text-center ji-orange-btn ${(!agreement || loading) ? 'disabled-btn' : ''}`}
            type="submit"
            disabled={loading || !agreement}
        >
            {loading ? `${dictionary["loading"]}...` : btnLabel || dictionary["leave_request"]}
        </button>
    </form>
}